'use strict';

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

require('lazysizes/plugins/object-fit/ls.object-fit');

require('lazysizes/plugins/parent-fit/ls.parent-fit');

require('lazysizes/plugins/rias/ls.rias');

require('lazysizes/plugins/bgset/ls.bgset');

require('lazysizes');

require('lazysizes/plugins/respimg/ls.respimg');

require('../../styles/theme.scss');

require('../../styles/theme.scss.liquid');

require('../sections/minicart');

var _themeA11y = require('@shopify/theme-a11y');

var _themeProductForm = require('@shopify/theme-product-form');

var _themeCurrency = require('@shopify/theme-currency');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//import {cookiesEnabled} from '@shopify/theme-cart';

// Common a11y fixes
//focusHash();
//bindInPageLinks();

// Apply a specific class to the html element for browser support of cookies.
/*
if (cookiesEnabled()) {
  document.documentElement.className = document.documentElement.className.replace(
    'supports-no-cookies',
    'supports-cookies',
  );
}
*/

$(document).ready(function () {

    if ($('body').hasClass('template-list-collections')) {
        window.location.href = "/collections/all";
    }

    $.fn.init_scroll = function () {
        var $window = $(window);

        var $toolbar = $('.site-notification');
        var $toolbar_height = $toolbar.length ? $toolbar.innerHeight() : 0;
        var $header_height = $('#shopify-section-header .site-header').innerHeight();

        var setup_fixed = function setup_fixed() {
            //console.log($window.width());
            if ($window.width() > 768) {
                if ($window.scrollTop() > $toolbar_height) {
                    $('body').not('.sticky').addClass('sticky');
                    $('#shopify-section-header').css('height', $header_height);
                } else {
                    $('body').removeClass('sticky');
                    $('#shopify-section-header').css('height', 'auto');
                }
            } else {
                $('body').removeClass('sticky');
                $('#shopify-section-header').css('height', 'auto');
            }
        };
        $window.scroll(function (e) {
            setup_fixed();
        });
        setup_fixed();
    };

    $('body').init_scroll();

    $.fn.init_header = function () {
        var $header = $(this);
        var $window = $(window);

        $('.site-header__menu-toggle').on('click', function () {
            //$( '.site-header' ).toggleClass( 'show-nav' );
            $('body').toggleClass('show-nav');
        });

        $('.site-header__search-toggle').on('click', function () {
            if ($('.site-header').hasClass('show-search')) {
                $('.site-header').removeClass('show-search');
            } else {
                $('.site-header').addClass('show-search');
                $('body').removeClass('show-nav');
            }
        });
        $('.site-header__search .close').on('click', function () {
            $('.site-header').removeClass('show-search');
        });
        $('.site-header__cart').on('click', function (event) {
            event.preventDefault();
            $('body').addClass('minicart-open');
        });

        var setup_hover_intent = function setup_hover_intent() {
            if ($window.width() > 768) {
                $('.site-header__nav > ul > li ').hoverIntent({
                    sensitivity: 1,
                    interval: 100,
                    over: function over() {
                        var fn = $(this);
                        $('.megamenu', fn).fadeIn(450);
                    },
                    timeout: 300,
                    out: function out() {
                        var fn = $(this);
                        $('.megamenu', fn).hide();
                    }
                });
                $('.site-header__nav > ul > li a.shop, .site-header__nav > ul > li a.collections').unbind('click');
                $('.site-header__nav .has-childs a').unbind('click');
            } else {
                $('.site-header__nav > ul > li ').unbind('mouseover mouseout');

                $('.site-header__nav > ul > li a.shop, .site-header__nav > ul > li a.collections').unbind('click');
                $('.site-header__nav .has-childs a').unbind('click');

                //setup click on shop, collection
                $('.site-header__nav > ul > li a.shop, .site-header__nav > ul > li a.collections').on('click', function (event) {
                    event.preventDefault();
                    var $obj = $(this);
                    var parent = $obj.parent();
                    var megamenu = parent.find('.megamenu');
                    if (megamenu.is(':visible')) {
                        megamenu.slideUp();
                    } else {
                        megamenu.slideDown();
                    }
                    //console.log('tuta');
                });
                //                $('.site-header__nav .has-childs a').on('click', function(event){
                //                    event.preventDefault();
                //                    var $obj = $(this);
                //                    var parent = $obj.parent();
                //                    var sub_menu= parent.find('ul');
                //                    if(sub_menu.is(':visible')){
                //                        sub_menu.slideUp();
                //                        $obj.removeClass('open');
                //                    }else{
                //                        sub_menu.slideDown();
                //                        $obj.addClass('open');
                //                    }
                //                });
            }
        };

        setup_hover_intent();

        $window.resize(function (e) {
            setup_hover_intent();
        });
    };

    $('.site_header').init_header();

    $.fn.init_site_notification = function () {
        $(this).each(function () {
            var $fn = $(this);

            var popupEnable = true,
                id = $fn.data('id'),
                showDelay = $fn.data('show-delay'),
                showAgainDelay = $fn.data('show-again-delay');

            var cookieName = 'site_notification_' + id;

            var showPopup = function showPopup() {

                // Check to see if the cookie exists
                if ($.cookie(cookieName)) {
                    popupEnable = false;
                }

                if (popupEnable) {
                    $fn.slideDown();
                }
            };
            var closePopup = function closePopup() {
                $.cookie(cookieName, 'shown', {
                    expires: showAgainDelay,
                    path: '/'
                });

                $fn.slideUp();
                $(window).trigger('scroll');
            };

            var popupTimeout = setTimeout(function () {
                showPopup();
            }, showDelay);

            $('.site-notification__close').on('click', function () {
                closePopup();
                return false;
            });
        });
    };
    $('.site-notification').init_site_notification();

    $.fn.init_newsletter_popup = function () {
        $(this).each(function () {
            var $fn = $(this);

            var popupEnable = $fn.data('enable'),
                id = $fn.data('id'),
                showDelay = $fn.data('show-delay'),
                showAgainDelay = $fn.data('show-again-delay'),
                homepageLimit = $fn.data('homepage-limit'),
                visitorLimit = $fn.data('visitor-limit'),
                isVisitor = $fn.data('visitor'),
                showFor = $fn.data('show-for');

            var cookieName = 'newsletter_popup_' + id;

            var $errors = $fn.find('.errors');
            if ($errors.length) {
                showDelay = 0;
            }

            var showPopup = function showPopup() {
                var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;


                // Disable popup if "only enable for visitor" and customer
                if (visitorLimit == true && isVisitor == false) {
                    popupEnable = false;
                }
                // Check to see if the cookie exists

                if ($.cookie(cookieName)) {
                    popupEnable = false;
                }

                // Check for homepage limit
                if (homepageLimit && !$('body').hasClass('template-index')) {
                    popupEnable = false;
                }

                if (force) {
                    popupEnable = true;
                }
                //popupEnable = true;
                if (popupEnable) {
                    $('body').addClass('newsletter-popup-open');

                    $.cookie(cookieName, 'shown', {
                        expires: showAgainDelay,
                        path: '/'
                    });
                }
            };
            var closePopup = function closePopup() {
                $('body').removeClass('newsletter-popup-open');
            };

            var popupTimeout = setTimeout(function () {
                var windowWidth = $(window).width();
                switch (showFor) {
                    case 'mobile':
                        if (windowWidth <= 768) {
                            showPopup();
                        }
                        break;
                    case 'desktop':
                        if (windowWidth > 768) {
                            showPopup();
                        }
                        break;
                    case 'both':
                        showPopup();
                        break;
                }
            }, showDelay);

            $('.newsletter-popup__close,.newsletter-popup__overlay,.newsletter-popup .no-thanks').on('click', function () {
                closePopup();
                return false;
            });
        });
    };
    $('.newsletter-popup').init_newsletter_popup();

    $.fn.init_cookie_popup = function () {
        $(this).each(function () {
            var $fn = $(this);

            var popupEnable = true,
                showDelay = $fn.data('show-delay'),
                showAgainDelay = $fn.data('show-again-delay');

            var cookieName = 'cookie_popup';
            var acceptCookieName = 'accept_cookie';

            var $errors = $fn.find('.errors');
            if ($errors.length) {
                showDelay = 0;
            }

            var showPopup = function showPopup() {

                // Check to see if the cookie exists
                if ($.cookie(cookieName)) {
                    popupEnable = false;
                }
                //popupEnable = true;
                if (popupEnable) {
                    //$fn.addClass('open');
                    $fn.fadeIn();

                    $.cookie(acceptCookieName, false, {
                        expires: showAgainDelay,
                        path: '/'
                    });
                }
            };
            var closePopup = function closePopup() {
                $.cookie(cookieName, 'shown', {
                    expires: showAgainDelay,
                    path: '/'
                });
                $fn.fadeOut();
                //$fn.removeClass('open');
            };

            var popupTimeout = setTimeout(function () {
                showPopup();
            }, showDelay);

            $('.cookie-popup__close,.cookie-popup__overlay').on('click', function () {
                closePopup();
                return false;
            });

            $('.cookie-popup .dismiss').on('click', function () {
                //console.log('close');
                closePopup();
                return false;
            });

            $('.cookie-popup .accept').on('click', function () {
                $.cookie(acceptCookieName, true, {
                    expires: showAgainDelay,
                    path: '/'
                });

                closePopup();
                return false;
            });

            //console.log("Nonessential cookies will be purged before navigation unless user consents to use.");
            window.addEventListener("beforeunload", function (event) {
                var acceptCookie = false;
                if ($.cookie(acceptCookieName) == 'true') {
                    acceptCookie = true;
                }
                //                console.log(acceptCookie);
                //                console.info($.cookie( acceptCookieName ));
                //                var all_cookies = document.cookie ? document.cookie.split('; ') : [];
                //                console.info(all_cookies);
                if (!acceptCookie) {
                    // check if can be cleared
                    // Purge nonessential JS cookies
                    var cookies = ["_s", "_shopify_fs", "_shopify_s", "_shopify_sa_p", "_shopify_sa_t", "_shopify_uniq", "_shopify_visit", "_shopify_y", "_y", "tracked_start_checkout"];
                    cookies.forEach(function (cookie) {
                        if (document.cookie.indexOf(cookie + "=") > -1) {
                            //console.log( 'GDPR Banner - unsetting cookie:', cookie );
                            document.cookie = cookie + '=;';
                            document.cookie = cookie + '=;domain=' + Shopify.shop + ';';
                        }
                    });
                }
            });
        });
    };
    $('.cookie-popup').init_cookie_popup();

    $.fn.init_footer = function () {
        var $footer = $(this);
        var $window = $(window);
        var cookieName = 'footer_popup';

        var tooglePopup = function tooglePopup() {
            var popupEnable = true;

            if (!$('body').hasClass('template-index')) {
                popupEnable = false;
            }
            if ($.cookie(cookieName)) {
                popupEnable = false;
            }
            if (popupEnable) {
                $.cookie(cookieName, 'shown', {
                    expires: 7,
                    path: '/'
                });

                $('.footer-popup__toggle').trigger('click');

                setTimeout(function () {
                    if ($('.footer-popup').hasClass('open')) {
                        $('.footer-popup__toggle').trigger('click');
                    }
                }, 3000);
            }
        };

        $('.footer-popup__toggle').on('click', function () {
            var $obj = $(this);
            if ($obj.parent().hasClass('open')) {
                $obj.parent().removeClass('open');
                $('.footer-popup__content').slideUp();
            } else {
                $obj.parent().addClass('open');
                $('.footer-popup__content').slideDown();
            }
        });

        tooglePopup();

        var setup_footer_menu = function setup_footer_menu() {
            if ($window.width() > 768) {

                $('.site-footer__navigation-title').unbind('click');
            } else {
                $('.site-footer__navigation-title').unbind('click');
                //setup click on shop, collection
                $('.site-footer__navigation-title').on('click', function (event) {
                    event.preventDefault();
                    var $obj = $(this);
                    var menu = $obj.next();
                    if (menu.is(':visible')) {
                        menu.slideUp();
                    } else {
                        menu.slideDown();
                    }
                });
            }
        };

        setup_footer_menu();

        $window.resize(function (e) {
            setup_footer_menu();
        });
    };

    $('.site_footer').init_footer();

    //    $('.site-header__nav > ul > li ').hoverIntent({
    //        sensitivity: 1,
    //        interval: 100,
    //        over: function(){
    //            var fn = $(this);
    //            $('.megamenu', fn).addClass('open');
    //        },
    //        timeout: 1000,
    //        out:function(){
    //            var fn = $(this);
    //            $('.megamenu', fn).removeClass('open');
    //        }
    //    });


    $('.slideshow__items').slick({
        fade: true,
        dots: true,
        arrows: false,
        autoplay: true,
        autoplaySpeed: $('.slideshow').data('autoplay-speed'),
        mobileFirst: true,
        responsive: [{
            breakpoint: 768,
            settings: {
                dots: true,
                appendDots: '.slideshow__nav-wrapper'
            }
        }]
    });

    $('.trending-now__items').slick({
        fade: false,
        dots: false,
        arrows: false,
        mobileFirst: true,
        variableWidth: true,

        responsive: [{
            breakpoint: 768,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 4,
                infinite: true,
                arrows: true,
                variableWidth: false
            }
        }]
    });

    $('.browse-by-categories__items').slick({
        fade: false,
        dots: true,
        arrows: false,
        mobileFirst: true,
        variableWidth: true,
        infinite: false,

        responsive: [{
            breakpoint: 768,
            settings: {
                slidesToShow: 5,
                slidesToScroll: 5,
                infinite: true,
                variableWidth: false,
                arrows: true,
                dots: false
            }
        }]
    });

    $('.collection-landing-features__items').slick({
        fade: false,
        dots: false,
        arrows: true,
        mobileFirst: true,
        infinite: false,

        responsive: [{
            breakpoint: 768,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3,

                arrows: false
            }
        }]
    });

    if ($('#instafeed').length) {
        var feed = new Instafeed({
            get: 'user',
            userId: 202358262,
            accessToken: '202358262.57d03ca.415f126d91a246459b9e9d7b6b7c8790',
            target: 'instafeed',
            resolution: 'standard_resolution',
            limit: 6,
            template: '<div class="instagram-feed__item"><a href="{{link}}" style="background-image: url({{image}})" target="_blank"></a></div>',
            after: function after() {}
        });
        feed.run();
    }

    $('.get-the-look__items').slick({
        fade: false,
        dots: false,
        arrows: true,
        mobileFirst: true,

        responsive: [{
            breakpoint: 768,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                infinite: true,
                arrows: true
            }
        }]
    });

    $('.shop-by-collections__items').slick({
        fade: false,
        dots: false,
        arrows: false,
        mobileFirst: true,
        variableWidth: true,
        autoplay: true,
        autoplaySpeed: $('.shop-by-collections').data('autoplay-speed'),

        responsive: [{
            breakpoint: 768,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                infinite: true,
                variableWidth: false,
                arrows: true
            }
        }]
    });

    var classes = {
        hide: 'hide'
    };

    var keyboardKeys = {
        ENTER: 13
    };

    var selectors = {
        submitButton: '[data-submit-button]',
        submitButtonText: '[data-submit-button-text]',
        comparePrice: '[data-compare-price]',
        comparePriceText: '[data-compare-text]',
        priceWrapper: '[data-price-wrapper]',
        imageWrapper: '[data-product-image-wrapper]',
        visibleImageWrapper: '[data-product-image-wrapper]:not(.' + classes.hide + ')',
        imageWrapperById: function imageWrapperById(id) {
            return selectors.imageWrapper + '[data-image-id=\'' + id + '\']';
        },
        productForm: '[data-product-quickview-form]',
        productPrice: '[data-product-price]',
        thumbnail: '[data-product-single-thumbnail]',
        thumbnailById: function thumbnailById(id) {
            return '[data-thumbnail-id=\'' + id + '\']';
        },
        thumbnailActive: '[data-product-single-thumbnail][aria-current]'
    };

    var quick_product = function () {
        function quick_product() {
            (0, _classCallCheck3.default)(this, quick_product);

            this.init();
        }

        (0, _createClass3.default)(quick_product, [{
            key: 'init',
            value: function () {
                var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                    var productFormElement;
                    return _regenerator2.default.wrap(function _callee$(_context) {
                        while (1) {
                            switch (_context.prev = _context.next) {
                                case 0:
                                    productFormElement = document.querySelector(selectors.productForm);
                                    _context.next = 3;
                                    return this.getProductJson(productFormElement.dataset.productHandle);

                                case 3:
                                    this.product = _context.sent;


                                    this.productForm = new _themeProductForm.ProductForm(productFormElement, this.product, {
                                        onOptionChange: this.onFormOptionChange.bind(this)
                                    });

                                    $('.product-quickview__images-items').slick({
                                        fade: true,
                                        arrows: true
                                    });

                                    $.fn.init_quantity = function () {
                                        $(this).each(function () {
                                            var $quantity = $(this);
                                            var $minus = $quantity.find('.minus');
                                            var $input = $quantity.find('input');
                                            var $plus = $quantity.find('.plus');

                                            $minus.on('click', function () {
                                                var current_val = parseInt($input.val());
                                                if (current_val >= 2) {
                                                    $input.val(current_val - 1);
                                                }
                                            });
                                            $plus.on('click', function () {
                                                var current_val = parseInt($input.val());
                                                $input.val(current_val + 1);
                                            });
                                        });
                                    };
                                    $('.product-quickview__quantity-input').init_quantity();

                                    jQuery('.swatch :radio').change(function () {

                                        var optionIndex = jQuery(this).closest('.swatch').attr('data-option-index');
                                        var optionValue = jQuery(this).val();
                                        var jSelector = jQuery(this).closest('form').find('.single-option-selector').eq(optionIndex);
                                        jSelector.val(optionValue);
                                        //.trigger( 'change' );
                                        var selector = document.querySelector('#' + jSelector.prop('id'));
                                        selector.dispatchEvent(new Event("change"));
                                    }); //.filter(':first').trigger('change');

                                    jQuery('.swatch').each(function () {
                                        jQuery(this).find(' :radio').filter(':first').trigger('change');
                                    });

                                    jQuery('.product-quickview__add-to-cart').on('click', function (event) {
                                        event.preventDefault();

                                        $.ajax({
                                            type: 'POST',
                                            url: '/cart/add.js',
                                            dataType: 'json',
                                            data: $('.shopify-product-form').serialize(),
                                            success: function success() {
                                                $.ajax({
                                                    type: 'GET',
                                                    url: '/cart/?view=minicart',
                                                    success: function success(result) {
                                                        $('.minicart__wrapper').html(result);
                                                        $('body').addClass('minicart-open');
                                                        $('.site-header__cart').addClass('has-items');
                                                        $.fancybox.close();
                                                    },
                                                    error: function error() {}
                                                });
                                            },
                                            error: function error() {}
                                        });
                                    });

                                case 11:
                                case 'end':
                                    return _context.stop();
                            }
                        }
                    }, _callee, this);
                }));

                function init() {
                    return _ref.apply(this, arguments);
                }

                return init;
            }()
        }, {
            key: 'getProductJson',
            value: function getProductJson(handle) {
                return fetch('/products/' + handle + '?view=getjson').then(function (response) {
                    return response.json();
                });
            }
        }, {
            key: 'onFormOptionChange',
            value: function onFormOptionChange(event) {
                var variant = event.dataset.variant;
                jQuery('.product-quickview__variants').val(variant.id);

                this.renderImages(variant);
                this.renderPrice(variant);
                this.renderSku(variant);
                this.renderComparePrice(variant);
                //this.renderSubmitButton( variant );
            }
        }, {
            key: 'renderSubmitButton',
            value: function renderSubmitButton(variant) {
                var submitButton = this.container.querySelector(selectors.submitButton);
                var submitButtonText = this.container.querySelector(selectors.submitButtonText);

                if (!variant) {
                    submitButton.disabled = true;
                    submitButtonText.innerText = theme.strings.unavailable;
                } else if (variant.available) {
                    submitButton.disabled = false;
                    submitButtonText.innerText = 'Add to bag';
                } else {
                    submitButton.disabled = true;
                    submitButtonText.innerText = theme.strings.soldOut;
                }
            }
        }, {
            key: 'renderImages',
            value: function renderImages(variant) {
                if (!variant || variant.featured_image === null) {
                    return;
                }

                this.renderFeaturedImage(variant.featured_image.id);
            }
        }, {
            key: 'renderFeaturedImage',
            value: function renderFeaturedImage(id) {

                //$('[data-id="'+id+'"]').trigger('click');

                $('.product-quickview__images-items').slick('slickGoTo', $('[data-id="' + id + '"]').data('slick-index'));
            }
        }, {
            key: 'renderPrice',
            value: function renderPrice(variant) {

                if (variant) {
                    $('.product-quickview__price span[data-product-price]').text((0, _themeCurrency.formatMoney)(variant.price, theme.moneyFormat));
                    //priceElement.innerText = formatMoney( variant.price, theme.moneyFormat );
                }
            }
        }, {
            key: 'renderSku',
            value: function renderSku(variant) {

                if (variant) {
                    $('.product-quickview__sku span').text(variant.sku);
                }
            }
        }, {
            key: 'renderComparePrice',
            value: function renderComparePrice(variant) {
                if (!variant) {
                    return;
                }

                var comparePriceElement = $(selectors.comparePrice);
                var compareTextElement = $(selectors.comparePriceText);

                if (!comparePriceElement || !compareTextElement) {
                    return;
                }

                if (variant.compare_at_price > variant.price) {
                    comparePriceElement.innerText = (0, _themeCurrency.formatMoney)(variant.compare_at_price, theme.moneyFormat);
                } else {
                    comparePriceElement.innerText = '';
                }
            }
        }]);
        return quick_product;
    }();

    $.fn.init_product_item = function () {
        $(this).each(function () {
            var $obj = $(this);

            if ($obj.find('.product-item__images .product-item__image').length > 1) {
                $obj.find('.product-item__images').slick({
                    fade: true,
                    dots: false, //true
                    arrows: true
                });

                $obj.on('mouseenter', function () {
                    $obj.find('.product-item__images').slick('slickNext');
                });
            }
            //$obj.find('.product-item__quick-view').fancybox();

            $obj.find('.product-item__quick-view').on('click', function (event) {
                event.preventDefault();
                var $button = $(this);

                var fancybox = $.fancybox.getInstance();

                var old_url = $button.data('url');
                var new_url = old_url.indexOf('?') == -1 ? old_url : old_url.substring(0, old_url.indexOf('?'));

                $.ajax({
                    type: 'GET',
                    url: new_url + '?view=quickview',
                    success: function success(result) {
                        //console.log(result);    
                        $.fancybox.open(result, {
                            afterShow: function afterShow() {
                                var product = new quick_product();
                            },
                            touch: false
                        });
                    },
                    error: function error() {}
                });
            });

            $obj.find('.product-item__add-to-cart').on('click', function (event) {
                event.preventDefault();
                var $button = $(this);

                if ($button.data('has-variants')) {
                    $button.parent().prev().trigger('click');
                } else {
                    $.ajax({
                        type: 'POST',
                        url: '/cart/add.js',
                        dataType: 'json',
                        data: $button.parent('.shopify-product-form').serialize() + '&id=' + $button.data('id') + '&quantity=1',
                        success: function success() {
                            $.ajax({
                                type: 'GET',
                                url: '/cart/?view=minicart',
                                success: function success(result) {
                                    $('.minicart__wrapper').html(result);
                                    $('body').addClass('minicart-open');
                                    $('.site-header__cart').addClass('has-items');
                                    $.fancybox.close();
                                },
                                error: function error() {}
                            });
                        },
                        error: function error() {}
                    });
                }
            });
        });
    };

    $('.product-item').init_product_item();

    $.fn.init_product_recommendations = function () {
        $(this).each(function () {
            var $fn = $(this);

            //console.info('recommndations');
            $.ajax({

                url: $fn.data('base-url') + "?section_id=product-recommendations&product_id=" + $fn.data('product-id') + "&limit=8",

                success: function success(result) {
                    //console.log(result);
                    $fn.html(result);

                    $('.product-recommendations__items').slick({
                        fade: false,
                        dots: false,
                        arrows: true,
                        mobileFirst: true,

                        responsive: [{
                            breakpoint: 768,
                            settings: {
                                slidesToShow: 3,
                                slidesToScroll: 3,
                                infinite: false,
                                arrows: true,
                                variableWidth: false
                            }
                        }]
                    });

                    $('.product-recommendations__items .product-item').init_product_item();
                },
                error: function error() {}
            });
        });
    };
    $('.product-recommendations-wrapper').init_product_recommendations();

    $.fn.init_page_lookbook = function () {
        $(this).each(function () {
            var $fn = $(this);

            var popup = $('.lookbook-images-popup', $fn);

            var slick_initialized = false;
            var slick = null;

            $('.lookbook-images__item').on('click', function () {
                var $item = $(this);
                var index = $('.lookbook-images__item').index($item);

                popup.fadeIn('slow', function () {

                    if (slick_initialized === false) {
                        slick = $('.lookbook-images-popup__items').slick({
                            fade: false,
                            dots: false,
                            arrows: true,
                            mobileFirst: true,

                            responsive: [{
                                breakpoint: 768,
                                settings: {
                                    slidesToShow: 3,
                                    slidesToScroll: 1,
                                    infinite: true,
                                    centerMode: true,
                                    //variableWidth: true,
                                    focusOnSelect: true,
                                    centerPadding: 0,
                                    speed: 500,
                                    initialSlide: index
                                }
                            }]
                        });
                        slick_initialized = true;
                    } else {
                        slick.slick('slickGoTo', index);
                    }
                });
                $('body').addClass('lookbook-images-popup-opened');
            });
            $('.lookbook-images-popup__close').on('click', function () {
                popup.fadeOut();
                $('body').removeClass('lookbook-images-popup-opened');
            });
            //
        });
    };

    $('.page-lookbook').init_page_lookbook();

    $.fn.init_faq = function () {
        $(this).each(function () {
            var $fn = $(this);

            var $content = $('.page-faq__content .shopify-section', $fn);
            var $navigation = $('.page-faq__navigation li');

            $navigation.on('click', function () {
                var $li = $(this);

                if ($li.hasClass('active')) {
                    return;
                }

                var index = $navigation.index($li);
                $content.eq(index).addClass('active');
                $content.eq(index).siblings().removeClass('active');
                $li.addClass('active');
                $li.siblings().removeClass('active');
            });

            $('.page-faq__info-item-question', $fn).on('click', function () {
                var $item = $(this).parent();
                if ($item.hasClass('active')) {
                    return;
                }
                $item.addClass('active');
                $item.siblings().removeClass('active');
            });

            $('.faq-videos__item-image .play', $fn).fancybox({
                openEffect: 'none',
                closeEffect: 'none',
                helpers: {
                    media: {}
                }
            });
        });
    };
    $('.page-faq').init_faq();

    $('.page-shop__order-selector-title').on('click', function () {
        var $obj = $(this);
        if ($obj.next().is(':visible')) {
            $obj.next().slideUp();
        } else {
            $obj.next().slideDown();
        }
    });
    $('.page-shop__nav>ul li.has-childs>a').on('click', function () {
        var $obj = $(this);
        var parent = $obj.parent();
        if (parent.hasClass('open')) {
            parent.removeClass('open');
        } else {
            parent.addClass('open');
        }
        return false;
    });

    $.fn.init_terms = function () {
        $(this).each(function () {
            var $fn = $(this);

            var $navigation = $('.page-terms__navigation>ul>li');
            var $content = $('.page-terms__content .shopify-section', $fn);

            $navigation.on('click', function () {
                var $li = $(this);

                if (!$li.hasClass('active')) {
                    var index = $navigation.index($li);
                    $content.eq(index).addClass('active');

                    $content.eq(index).siblings().removeClass('active');
                    $li.addClass('active');
                    $li.siblings().removeClass('active');
                    $li.siblings().find('.nav').html('');
                }

                var $investment_packages = $('.page-terms__content .shopify-section.active');

                //                const offsetTop = $investment_packages.offset().top - 500;
                //                $("html, body").animate({ scrollTop: offsetTop });

                tocbot.destroy();
                tocbot.init({
                    // Where to render the table of contents.
                    tocSelector: '.page-terms__navigation li.active .nav',
                    // Where to grab the headings to build the table of contents.
                    contentSelector: '.page-terms__content .shopify-section.active',
                    // Which headings to grab inside of the contentSelector element.
                    headingSelector: 'h1, h2, h3'
                });
            }).filter(":first").trigger('click');

            //            $( '.page-terms__navigation', $fn ).tacky( {
            //                parentSelector: '.page-terms__navigation .item-title',
            //                activeClass: 'active1'
            //            } );
            //            console.log($('#shopify-section-footer').innerHeight());
            //            $(".page-terms__navigation").sticky({
            //                topSpacing:0,
            //                bottomSpacing: $('#shopify-section-footer').outerHeight()
            //            });

            var a = new StickySidebar('#sidebar', {
                topSpacing: 60,
                bottomSpacing: 0,
                containerSelector: '.page-terms__wrapper',
                innerWrapperSelector: '.page-terms__navigation',
                resizeSensor: true
            });
        });
    };
    $('.page-terms').init_terms();

    $.fn.init_fromm_squad_person = function () {
        $(this).each(function () {
            var $fn = $(this);

            var $images = $('.fromm-squad-persons__item-images', $fn);
            var $thumbs = $('.fromm-squad-persons__item-thumbs', $fn);

            $images.slick({
                fade: true,
                arrows: true,
                asNavFor: $thumbs,
                infinite: false
            });
            $thumbs.slick({
                //fade: true,
                arrows: false,
                slidesToShow: 4,

                asNavFor: $images,
                focusOnSelect: true,
                mobileFirst: true,
                vertical: false,
                infinite: false,
                //variableWidth: true,
                responsive: [{
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 5,
                        slidesToScroll: 5
                    }
                }]
            });

            var $products = $('.fromm-squad-persons__item-products', $fn);

            $products.slick({
                arrows: true,
                slidesToShow: 2,
                slidesToScroll: 2
            });

            var $info_toggle = $('.fromm-squad-persons__item-more-info', $fn);
            var $info_content = $('.fromm-squad-persons__item-info', $fn);

            $info_toggle.on('click', function () {
                var $obj = $(this);
                if ($obj.hasClass('open')) {
                    $obj.removeClass('open');
                    $info_content.slideUp();
                } else {
                    $obj.addClass('open');
                    $info_content.slideDown();
                }
            });
        });
    };
    $('.fromm-squad-persons__item').init_fromm_squad_person();

    var $window = $(window);

    $('.fromm-squad-persons__persons').on('init', function () {
        $(".fromm-squad-persons__person").on('click', function () {

            var $obj = $(this);
            //var index = $(".fromm-squad-persons__person").index($obj);
            var index = $obj.data('slick-index');

            $('html, body').animate({
                scrollTop: $(".fromm-squad-persons__item").eq(index).offset().top - ($window.width() > 768 ? 69 : -1)
            }, 1000);
        });
        $(".fromm-squad-persons__person a").on('click', function (event) {
            event.stopPropagation();
        });
    });

    $('.fromm-squad-persons__persons').slick({
        fade: false,
        dots: false,
        arrows: true,
        mobileFirst: true,
        infinite: false,
        responsive: [{
            breakpoint: 768,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 4,
                infinite: false,
                arrows: true
            }
        }]
    });

    $.fn.init_blog = function () {
        $(this).each(function () {
            var $fn = $(this);

            $('.page-blog__featured-posts-items', $fn).slick({
                fade: true,
                dots: true,
                arrows: false,
                autoplay: true,
                autoplaySpeed: 2000,
                mobileFirst: true,
                appendDots: '.page-blog__featured-posts-nav',

                responsive: [{
                    breakpoint: 1100,
                    settings: {
                        //infinite: true,
                        fade: false,
                        variableWidth: true
                    }
                }]
            });
        });
    };
    $('.page-blog').init_blog();

    $.fn.init_article = function () {
        $(this).each(function () {
            var $fn = $(this);

            $('.page-article__image .play', $fn).fancybox({
                openEffect: 'none',
                closeEffect: 'none',
                helpers: {
                    media: {}
                }
            });
            $('.article-products__items', $fn).slick({
                fade: false,
                dots: false,
                arrows: true,
                slidesToShow: 3,
                slidesToScroll: 3,
                infinite: true,
                responsive: [{
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }]
            });
        });
    };
    $('.page-article').init_article();

    $.fn.init_cart = function () {
        $(this).each(function () {
            var $fn = $(this);

            $.fn.init_quantity = function () {
                $(this).each(function () {
                    var $quantity = $(this);
                    var $minus = $quantity.find('.minus');
                    var $input = $quantity.find('input');
                    var $plus = $quantity.find('.plus');

                    $minus.on('click', function () {
                        var current_val = parseInt($input.val());
                        if (current_val >= 2) {
                            $input.val(current_val - 1);
                        }
                    });
                    $plus.on('click', function () {
                        var current_val = parseInt($input.val());
                        $input.val(current_val + 1);
                    });
                });
            };
            $('.page-cart__product-quantity').init_quantity();
        });
    };
    $('.page-cart').init_cart();

    var newsletter_popup = $('.newsletter-popup');
    $('.site-footer__newsletter-link').on('click', function () {
        newsletter_popup.addClass('open');
        return false;
    });
    $('.newsletter-popup .close').on('click', function () {
        newsletter_popup.removeClass('open');
        return false;
    });

    // On before slide change
    $('.collection-landing-intro__mobile-nav ul').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        var elSlide = $(slick.$slides[nextSlide]);
        window.location.href = elSlide.find('a').prop('href');
        //console.log(elSlide);
    });
    $('.collection-landing-intro__mobile-nav ul').slick({
        initialSlide: $('.collection-landing-intro__mobile-nav ul li').index($('.collection-landing-intro__mobile-nav ul li.active')),
        prevArrow: '<button type="button" class="slick-prev"><i class="fa fa-chevron-left"></i></button>',
        nextArrow: '<button type="button" class="slick-next"><i class="fa fa-chevron-right"></i></button>'
    });

    //    var sliding_popup = $('.sliding-popup');
    //    $(window).scroll(function() {
    //        if($(window).scrollTop() + $(window).height() == $(document).height()) {
    //            sliding_popup.addClass('open');
    //        }
    //    });
    //    $('.sliding-popup .close').on('click', function(){
    //        sliding_popup.removeClass('open');
    //        return false;
    //    });
});